import deposit from './deposit';
import withdraw from './withdraw';
import utils from './utils';
import user from './user';

export default {
  deposit: deposit,
  withdraw: withdraw,
  utils: utils,
  user: user
};